__turbopack_context__.v({
  "dropdown": "combobox-module__48sLCq__dropdown",
  "option": "combobox-module__48sLCq__option",
  "options": "combobox-module__48sLCq__options",
});
